import { render, staticRenderFns } from "./TemplateBlock.vue?vue&type=template&id=7877d593&scoped=true"
import script from "./TemplateBlock.vue?vue&type=script&lang=js"
export * from "./TemplateBlock.vue?vue&type=script&lang=js"
import style0 from "./TemplateBlock.vue?vue&type=style&index=0&id=7877d593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7877d593",
  null
  
)

export default component.exports